import { memo, type MouseEventHandler } from 'react';

import clsx from 'clsx';

import { ReactComponent as ArrowIcon } from '@/assets/images/arrow-right.svg?react';
import { ReactComponent as ChevronIcon } from '@/assets/images/chevron.svg?react';
import { ReactComponent as CloseIcon } from '@/assets/images/close.svg?react';

import { Icon } from '../../icon';
import { type BannerProps } from '../model/banner.types';

import s from './Banner.module.scss';

export const Banner = memo(
  ({
    className,
    onClose,
    onClick,
    icon,
    title,
    subtitle,
    color = 'basic',
    subtitleChevron,
  }: BannerProps) => {
    const handleBannerClose: MouseEventHandler = (e) => {
      e.stopPropagation();
      onClose && onClose();
    };
    return (
      <div className={clsx(s.container, s[`${color}`], className)} onClick={onClick}>
        <div className={s.info}>
          {!!icon && <Icon className={s.icon} icon={icon} />}
          <div className={s.text}>
            <span className={s.title}>{title}</span>
            {!!subtitle && (
              <span className={s.subtitle}>
                {subtitle}
                {(subtitleChevron || !!onClose) && !!onClick && (
                  <ChevronIcon className={s['subtitle-arrow']} />
                )}
              </span>
            )}
          </div>
        </div>
        {onClose ? (
          <button className={s.close} onClick={handleBannerClose}>
            <CloseIcon />
          </button>
        ) : (
          !!onClick && !subtitleChevron && <ArrowIcon className={s.arrow} />
        )}
      </div>
    );
  }
);

Banner.displayName = 'Banner';
